
import { Component, Vue, Prop } from 'vue-property-decorator';
// eslint-disable-next-line
import { Form } from 'element-ui';
// import moment from 'moment';
import { toast } from '../../../utils/common';
import { addMsgPush, getMsgDetail } from '@/api/exchange-code';
// eslint-disable-next-line
import { eType, eFilterType, eHreftype, iFilter } from '@/interface/message';
import { Areas } from '@/utils/area';
import Upload from '@/components/ImagesUpload/upload.vue';
// eslint-disable-next-line
import { iUploadeImagesList } from '@/interface/imageUpload';
import { getValidSpecialGoods } from '@/api/top-up-active';
import Item from './filter-item.vue';
import moment from 'moment';
import { PriceQuery } from '@/mixins/price_query';
import { formatChannels } from '@/utils/validate';
import { gradeItem, shortGoodsItem } from '@/interface/purchase';

@Component({
  components: { Upload, Item },
  filters: {
    yyyy_mm_dd_two(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
})
export default class extends Vue {
  @Prop() messageDialog!: boolean;
  @Prop({ default: 1 }) msgId!: number;
  @Prop() getUserId!: Function;
  priceQuery = new PriceQuery();

  title: string = '新建消息';
  targetClient: Array<string> = [];
  activeGoodsId: number = -1;
  goodsOptions: Array<shortGoodsItem> = [{ id: -1, name: '请选择', type: -1 }];
  options: Array<gradeItem> = [{ grade: -1, name: '请选择' }];
  extend: { grade_type: number; grade_id: number } = {
    grade_type: 1,
    grade_id: -1,
  };
  channelFilters: Array<string> = [];
  channels: string = '';
  messageForm: {
    title: string;
    content: string;
    send_at: any;
    valid_end: any;
    valid_start: any;
    to: string;
    button_text: string;
    href: string;
    status: boolean;
    filter: iFilter;
    type: eType;
    filter_type: eFilterType;
    href_type: eHreftype;
    seq: string;
    pic_url: string;
    // android_pic_url: string;
    button_type: number;
    href_type_value: number;
    send_client: string;
    extend?: object;
    channel_filter: any;
    seq_type?: number;
    // channelFilters?: Array<string>;
    // channels?: string;
  } = {
    button_type: 0,
    href_type_value: 2,
    seq: '',
    pic_url: '',
    // android_pic_url: '',
    href_type: eHreftype.NO,
    filter_type: 2,
    type: 1,
    title: '',
    content: '',
    send_at: '',
    valid_end: '',
    to: '',
    button_text: '',
    href: '',
    status: true,
    filter: {
      //注册天数， 不限则全填0
      register_day_rule: {
        minimum: null,
        maxima: null,
        limit_type: 1,
      },
      pay_amount_rule: {
        minimum: null,
        maxima: null,
        limit_type: 1,
      },
      pay_count_rule: {
        minimum: null,
        maxima: null,
        limit_type: 1,
      },
      district_rule: {
        prov_id: [],
        limit_type: 1,
      },
    },
    valid_start: undefined,
    send_client: '',
    // channelFilters: [],
    // channels: '',
    channel_filter: {},
    seq_type: 0,
  };
  rules: any = {
    title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
    content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
    send_at: [{ required: true, message: '请选择时间', trigger: 'blur' }],
    valid_end: [{ required: true, message: '请选择时间', trigger: 'blur' }],
    // type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
    // codRadio: [{ message: '请选择兑换码/推广码', trigger: 'blur' }],
    filter_type: [{ required: true, message: '请选择推送用户', trigger: 'blur' }],
    // channelFilters: [{ type: 'array', required: true, message: '请至少选择一个用户绑定类型', trigger: 'change' }],
    // channels: [{ required: true, message: '请输入推荐码/渠道标, 多个用逗号隔开', trigger: 'blur' }],
    // provinceType: [{ required: true, message: '请选择地区', trigger: 'blur' }],
    // button_type: [{ required: true, message: '请选择按钮', trigger: 'blur' }],
    seq: [{ required: true, trigger: 'blur', validator: this.checkSeq }],
    enterImgUpload: [{ required: true, trigger: 'blur', validator: this.checkenterImgLength }],
    androidEnterImgUpload: [{ required: true, trigger: 'blur', validator: this.checkAndroidEnterImgLength }],
    provinceType: [{ required: true, trigger: 'blur', validator: this.checkProvinceType }],
    filterRegister: [{ required: true, trigger: 'blur', validator: this.checkFilterRegister }],
    filterReMoney: [{ required: true, trigger: 'blur', validator: this.checkFilterReMoney }],
    filterReCount: [{ required: true, trigger: 'blur', validator: this.checkFilterReCount }],
    href: [{ required: true, trigger: 'blur', validator: this.checkHrefType }],
  };
  typeList: any = {
    letter: eType.LETTER,
    picture: eType.PICTURE,
  };
  filterTypeList: any = {
    userId: eFilterType.BYUSERID,
    userType: eFilterType.BYTUSERYPE,
    referralCode: eFilterType.REFERRAL_CODE,
    channelIden: eFilterType.CHANNEL_IDEN,
  };
  toFileType = [
    { id: eHreftype.NO, value: '无' },
    { id: eHreftype.PC, value: '内部' },
    { id: eHreftype.THIRD, value: '三方链接' },
    { id: eHreftype.CODE, value: '兑换码兑换' },
    { id: eHreftype.SP_GOODS, value: '特殊商品' },
  ];
  pcPageList: any = [
    { id: 1, value: '充值' },
    { id: 2, value: '领云币' },
    { id: 3, value: '兑换码' },
    { id: 4, value: '推广员' },
    { id: 5, value: '云币充值' },
    { id: 6, value: '周期卡充值' },
  ];

  codRadio: number = 0;
  provinceList: any = [];
  hrefTypeCode: eHreftype = eHreftype.CODE; //兑换兑换
  isCode: boolean = false; //是否选择了推广码
  pc = eHreftype.PC;
  third = eHreftype.THIRD;
  spGoods = eHreftype.SP_GOODS;
  enterImgUpload: iUploadeImagesList[] = [];
  androidEnterImgUpload: iUploadeImagesList[] = [];
  activeLevel: string = '';
  /* 验证码 */
  checkSeq(rule: any, value: any, callback: any) {
    if (this.codRadio == 0) {
      //无推广码
      return callback();
    } else {
      if (!this.messageForm.seq) {
        return callback(new Error('请输入推广码'));
      }
      return callback();
    }
  }

  /* 图片 */
  checkAndroidEnterImgLength(rule: any, value: any, callback: any) {
    if ((this.androidEnterImgUpload && this.androidEnterImgUpload.length > 0) || this.messageForm.type == eType.LETTER) {
      return callback();
    }
    return callback(new Error('请选择安卓推送图片'));
  }
  /* 图片 */
  checkenterImgLength(rule: any, value: any, callback: any) {
    if ((this.enterImgUpload && this.enterImgUpload.length > 0) || this.messageForm.type == eType.LETTER) {
      return callback();
    }
    return callback(new Error('请选择图片'));
  }
  /* 省份 */
  checkProvinceType(rule: any, value: any, callback: any) {
    //this.provinceType 0 无省份
    if (this.messageForm.filter.district_rule.prov_id.length > 0 || this.messageForm.filter.district_rule.limit_type === 1) {
      return callback();
    }
    return callback(new Error('请选择省份'));
  }

  checkFilterRegister(rule: any, value: any, callback: any) {
    const { limit_type, minimum, maxima } = this.messageForm.filter.register_day_rule;

    if (limit_type == 2) {
      if (maxima == undefined || minimum == undefined) {
        return callback(new Error('请输入XX到XX天进行设置'));
      } else if (maxima <= minimum) {
        return callback(new Error('注册最大天数必须大于注册最小天数'));
      }
    }
    return callback();
  }
  checkFilterReMoney(rule: any, value: any, callback: any) {
    const { limit_type, minimum, maxima } = this.messageForm.filter.pay_amount_rule;
    if (limit_type == 2) {
      if (maxima == undefined || minimum == undefined) {
        return callback(new Error('请输入XX到XX的金额进行设置'));
      } else if (maxima < minimum) {
        return callback(new Error('充值最大金额必须大于等于充值最小金额'));
      }
    }
    return callback();
  }
  checkFilterReCount(rule: any, value: any, callback: any) {
    const { limit_type, minimum, maxima } = this.messageForm.filter.pay_count_rule;
    if (limit_type == 2) {
      if (maxima == undefined || minimum == undefined) {
        return callback(new Error('请输入XX到XX充值次数进行设置'));
      } else if (maxima < minimum) {
        return callback(new Error('充值最大次数必须大于等于充值最小次数'));
      }
    }
    return callback();
  }
  checkHrefType(rule: any, value: any, callback: any) {
    const { href_type, href } = this.messageForm;
    if (href_type == this.third) {
      if (!href) {
        return callback(new Error('请输入第三方连接地址'));
      }
    }
    return callback();
  }

  getPCValue() {
    if (this.messageForm.href_type == this.pc) {
      const res = this.pcPageList.filter((item: any) => {
        return item.id == this.messageForm.href;
      });
      return res[0].value;
    }
  }
  hrefTypeShow(item: any) {
    let a = false;
    if (this.msgId > 0) {
      //详情
      a = true;
    } else if (this.isCode) {
      //有验证码
      a = true;
    } else if (item.id == eHreftype.CODE && !this.isCode) {
      //无验证码 兑换码设置为不操作
      a = true;
    } else if (this.messageForm.button_type == 0) {
      //按钮为无
      a = true;
    }

    return a;
  }
  //省份
  getProvinceName() {
    let values = '';
    const { prov_id, limit_type } = this.messageForm.filter.district_rule;
    if (limit_type == 2) {
      prov_id.forEach((item: any) => {
        const res = this.provinceList.filter((pitem: any) => pitem.id == item)[0].name;
        values = values + res + ',';
      });
      values = values.substring(0, values.length - 1);
    }
    return values;
  }

  changeTarget() {
    if (this.targetClient.length) {
      this.messageForm.send_client = this.targetClient.join(',');
    } else {
      this.messageForm.send_client = '';
    }
  }

  hrefTypeChange() {
    const _this: any = this;
    if (_this.messageForm.href_type_value === 5) {
      _this.priceQuery.getMarketingGrades('coin').then((list: Array<gradeItem>) => {
        _this.options = list;
        _this.options.unshift({ grade: -1, name: '请选择' });
        _this.extend.grade_type = 1;
      });
    } else if (this.messageForm.href_type_value === 6) {
      _this.priceQuery.getMarketingGrades('card').then((list: Array<gradeItem>) => {
        _this.options = list;
        _this.options.unshift({ grade: -1, name: '请选择' });
        _this.extend.grade_type = 2;
      });
    }
    _this.extend.grade_id = -1;
  }

  /* checkProvinceType 检查省份 */
  submitMessageForm(formName: any) {
    const self = this;

    if (!this.messageForm.send_client) {
      this.$message.error('请选择需要推送的客户端类型');
      return;
    }
    if (self.messageForm.href_type == self.pc && [5, 6].indexOf(self.messageForm.href_type_value) > -1 && self.extend.grade_id === -1) {
      this.$message.error('请选择需要绑定的档位');
      return;
    }
    if (self.messageForm.href_type == self.spGoods && self.activeGoodsId === -1) {
      this.$message.error('请选择商品');
      return;
    }
    if (self.messageForm.filter_type === self.filterTypeList.referralCode || self.messageForm.filter_type === self.filterTypeList.channelIden) {
      if (!self.channelFilters.length) {
        self.$message.error('请至少选择一个用户绑定类型');
        return;
      } else if (!self.channels) {
        self.$message.error('请输入推荐码/渠道标, 多个用逗号隔开');
        return;
      }
    }

    (this.$refs[formName] as Form).validate((valid: boolean) => {
      if (valid) {
        if (this.targetClient.length) {
          this.messageForm.send_client = this.targetClient.join(',');
        }
        if (self.messageForm.href_type == self.pc && [5, 6].indexOf(self.messageForm.href_type_value) > -1) {
          this.messageForm.extend = this.extend;
        }
        if (self.messageForm.href_type == self.spGoods && self.activeGoodsId > -1) {
          const activeGoods = self.goodsOptions.find(x => x.id === self.activeGoodsId);
          if (activeGoods) {
            this.messageForm.extend = { sp_good_id: activeGoods.id, sp_good_name: activeGoods.name };
          }
        }
        if (this.messageForm.to) {
          const idArr = this.messageForm.to.split(',');
          const isValid = idArr.every(item => {
            return Number(item) > 0;
          });
          if (isValid) {
            //add
            self.addMessagePush();
          } else {
            toast('推送用户ID输入错误', 'error');
          }
        } else {
          self.addMessagePush();
        }
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  closeMessageForm() {
    // (this.$refs[formName] as Form).resetFields();
    this.$emit('update:messageDialog', false);
    // this.messageDialog = false;
  }
  handleClose() {
    // (this.$refs['messageForm'] as Form).resetFields();
    this.$emit('update:messageDialog', false);
  }
  sendAtChange(val: Date) {
    if (this.messageForm.valid_end && val > this.messageForm.valid_end) {
      toast('结束时间不能小于开始时间', 'error');
      this.messageForm.send_at = '';
      return;
    }
  }
  validEndChange(val: Date) {
    if (this.messageForm.send_at && val < this.messageForm.send_at) {
      toast('结束时间不能小于开始时间', 'error');
      this.messageForm.valid_end = '';
      return;
    }
  }
  async addMessagePush() {
    try {
      let newAddMessage = JSON.parse(JSON.stringify(this.messageForm));

      newAddMessage.send_at = newAddMessage.send_at / 1000;
      newAddMessage.valid_end = newAddMessage.valid_end / 1000;
      newAddMessage.valid_start = newAddMessage.send_at;
      //推广码
      if (this.codRadio == 0) {
        newAddMessage.seq = '';
      }
      const { type, filter_type, to, href_type, filter } = newAddMessage;
      //图片
      if (type == this.typeList.picture) {
        newAddMessage.pic_url = this.enterImgUpload[0] ? this.enterImgUpload[0].url : '';
        // newAddMessage.android_pic_url = this.androidEnterImgUpload[0] ? this.androidEnterImgUpload[0].url : '';
      }
      /*  推送用户 用户类型，有股ID*/
      if (filter_type == this.filterTypeList.userType) {
        newAddMessage.to = [];
      } else {
        let toArr = [];
        if (to) {
          toArr = newAddMessage.to.split(',').map((item: any) => {
            item = Number(item);
            return item;
          });
        }
        newAddMessage.to = toArr;
      }

      if (href_type == eHreftype.PC) {
        newAddMessage.href = JSON.stringify(newAddMessage.href_type_value);
      }
      //省份
      const { limit_type, prov_id } = filter.district_rule;
      if (limit_type == 2 && prov_id.length > 0) {
        newAddMessage.filter.district_rule.prov_id = prov_id.map((i: string) => parseInt(i, 0));
      }
      //金额
      const { limit_type: pLimitType, minimum, maxima } = filter.pay_amount_rule;
      //
      if (pLimitType == 2) {
        newAddMessage.filter.pay_amount_rule.minimum = minimum * 10 * 10;
        newAddMessage.filter.pay_amount_rule.maxima = maxima * 10 * 10;
      }
      if (newAddMessage.filter_type == this.filterTypeList.referralCode || newAddMessage.filter_type == this.filterTypeList.channelIden) {
        newAddMessage.channel_filter = {};
        if (this.channelFilters.length) {
          newAddMessage.channel_filter.is_already_bind = this.channelFilters.indexOf('is_already_bind') > -1;
          newAddMessage.channel_filter.is_new_bind = this.channelFilters.indexOf('is_new_bind') > -1;
          newAddMessage.channel_filter.channels = formatChannels(this.channels);
        }
      }
      const res = await addMsgPush({
        ...newAddMessage,
      });

      if (res.code == 0) {
        toast('保存成功');
        this.handleClose();
        this.$emit('addMessageSuccess', true);
      } else {
        toast('保存失败！' + res.msg, 'error');
      }
      //
    } catch (err) {
      //
      console.error(err);
    }
  }
  /* 跳转 */
  changeToType() {
    const _this = this;
    if (this.messageForm.href_type == eHreftype.CODE) {
      this.isCode = true;
      this.messageForm.button_type = 1;
      this.codRadio = 1;
    } else if (this.messageForm.href_type == eHreftype.SP_GOODS) {
      getValidSpecialGoods({ page: 0, page_size: 0 })
        .then((resp: any) => {
          if (resp!.code == 0) {
            _this.goodsOptions = resp.data.list;
          }
        })
        .catch(() => {
          toast('获取商品失败', 'error');
        });
    }
  }
  /* 推广码 */
  changeCode() {
    if (this.codRadio === 1) {
      this.isCode = true;
      this.messageForm.button_type = 1;
      this.messageForm.href_type = eHreftype.CODE;
      this.messageForm.seq_type = 2;
    } else {
      this.isCode = false;
      this.messageForm.button_type = 1;
      this.messageForm.href_type = eHreftype.PC;
      this.messageForm.seq_type = 0;
    }
  }
  /* 按钮 */
  changeButton() {
    if (this.messageForm.button_type == 1) {
      this.messageForm.href_type = eHreftype.PC;
    } else {
      this.messageForm.href_type = eHreftype.NO;
    }
  }
  handleChangeType(type: number) {
    //选择了又兑换码，推广码
    switch (type) {
      case 1:
        //如果选择了有推广码
        this.changeCode();
        break;
      case 2:
        //如果选择了按钮有
        this.changeButton();
        break;
      case 3:
        //跳转类型
        this.changeToType();
        break;
    }
  }
  mounted() {
    this.provinceList = Areas;

    if (this.msgId > 0) {
      this.title = '消息详情';
      this.init();
    }
  }
  async init() {
    const res = await getMsgDetail(this.msgId);
    this.messageForm = res.data;
    this.targetClient = this.messageForm.send_client ? this.messageForm.send_client.split(',') : [];
    if ([5, 6].indexOf(parseInt(res.data.href)) > -1) {
      this.messageForm.href_type_value = parseInt(res.data.href);
      if (res.data.extend) {
        const list: any = await this.priceQuery.getMarketingGrades(parseInt(res.data.href) === 5 ? 'coin' : 'card');
        const level = list.find((x: any) => x.grade === res.data.extend.grade_id);
        this.activeLevel = level.name;
      }
    } else if (res.data.href_type === eHreftype.SP_GOODS) {
      // 特殊商品
      const { data } = await getValidSpecialGoods({ page: 0, page_size: 0 });
      this.goodsOptions = data.list;
      this.activeGoodsId = res.data.extend.sp_good_id;
    }
    if (this.messageForm.seq != '') {
      this.codRadio = 1;
    }
    if (this.messageForm.channel_filter.is_already_bind) {
      this.channelFilters.push('is_already_bind');
    }
    if (this.messageForm.channel_filter.is_new_bind) {
      this.channelFilters.push('is_new_bind');
    }
    if (this.messageForm.channel_filter.channels) {
      this.channels = this.messageForm.channel_filter.channels.join(',');
    }
  }
}
